import type { Command, JsonValue, RecordDefinition } from "@e308/core";
import { rejectUnlessActiveBorder } from "./border-guards.js";
import { setInfrastructureTarget } from "./combat-state.js";
import { rejectIfEliminated } from "./command-guards.js";
import type { SeatModel } from "./content-types.js";
import type { Micro } from "./exact-numbers.js";
import type { LockedMatchSetup } from "./lifecycle-state.js";
import type { MatchLifecycleState } from "./lifecycle-types.js";
import type { ConflictIntent } from "./types.js";

type CombatIntent = Extract<ConflictIntent, { readonly kind: "set-infrastructure-target" }>;

export function combatCommandFor(
  model: SeatModel,
  intent: CombatIntent,
  seatById: ReadonlyMap<string, SeatModel>,
  lifecycle: RecordDefinition<MatchLifecycleState & JsonValue>,
  setup: LockedMatchSetup,
): Command<Micro> {
  return {
    id: `intent:${model.seat.id}:combat`,
    execute: (transaction) => {
      rejectIfEliminated(transaction, model);
      const target = seatById.get(intent.borderId);
      if (!target) transaction.reject({ code: "invalid-target", id: intent.borderId });
      if (setup.teamBySeat[model.seat.id] === setup.teamBySeat[intent.borderId])
        transaction.reject({ code: "invalid-target", id: intent.borderId });
      rejectUnlessActiveBorder(transaction, model, target as SeatModel, lifecycle);
      transaction.setRecord(
        model.combat,
        setInfrastructureTarget(
          transaction.getRecord(model.combat),
          intent.borderId,
          intent.target,
        ),
      );
    },
  };
}
